import React from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { FaTimes } from "react-icons/fa";
import { numericalErr } from "../../shared/sharedConstants";
import { ErrorBox, ErrorItem } from "./style";

interface ErrorItems {
  empty?: boolean;
  upperCase?: boolean;
  number?: boolean;
  specialChars?: boolean;
  eightChars?: boolean;
  showMatch?: boolean;
  errors?: any;
  values?: any;
  pwToCheck?: any;
  grey?: boolean;
}

const FormErrors = ({
  empty,
  upperCase,
  number,
  specialChars,
  eightChars,
  showMatch,
  errors,
  values,
  pwToCheck,
  grey,
}: ErrorItems) => {
  const handleCheckPassword = () => {
    if (values?.confirmPassword && values?.confirmPassword.length > 0) {
      let checkIsCorrect =
        values?.[pwToCheck].length > 0 &&
        ((values?.newPassword === values?.confirmPassword) as any);
      return checkIsCorrect;
    }

    if (values?.password__c && values?.password__c.length > 0) {
      if (
        values?.password !== "" &&
        values?.password__c !== "" &&
        values?.password === values?.password__c
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <ErrorBox>
      {/* @ts-ignore */}
      <ErrorItem isCorrect={empty} grey>
        {" "}
        {empty ? <AiOutlineCheck /> : <FaTimes />}
        Must not be empty{" "}
      </ErrorItem>

      {/* @ts-ignore */}
      <ErrorItem isCorrect={upperCase} grey>
        {" "}
        {upperCase ? <AiOutlineCheck /> : <FaTimes />}
        At least an uppercase/lowercase character
      </ErrorItem>

      {/* @ts-ignore */}
      <ErrorItem isCorrect={number} grey>
        {" "}
        {number ? <AiOutlineCheck /> : <FaTimes />}
        {numericalErr}
      </ErrorItem>

      {/* @ts-ignore */}
      <ErrorItem isCorrect={specialChars} grey>
        {" "}
        {specialChars ? <AiOutlineCheck /> : <FaTimes />}
        At least one special character
      </ErrorItem>

      {/* @ts-ignore */}
      <ErrorItem isCorrect={eightChars} grey>
        {" "}
        {eightChars ? <AiOutlineCheck /> : <FaTimes />}
        At least 8 characters
      </ErrorItem>

      {showMatch && (
        <ErrorItem
          grey
          // @ts-ignore
          isCorrect={!!handleCheckPassword()}
        >
          {" "}
          {
            // !errors?.[pwToCheck] && ((values?.[pwToCheck].length > 0) as any)
            handleCheckPassword() ? <AiOutlineCheck /> : <FaTimes />
          }
          Passwords must match
        </ErrorItem>
      )}
    </ErrorBox>
  );
};

export default FormErrors;
